<template>
  <div class="relative">
    <button
      v-click-outside="handleClickOutside"
      data-dropdown-toggle="dropdownHover"
      data-dropdown-trigger="hover"
      class="no-underline text-secondary text-lg hover:text-secondary py-1.5 border-b-2 border-b-transparent duration-200"
      type="button"
      @click="open = !open"
      @hover="open = !open"
    >
      <slot name="dropdownText" />
    </button>

    <!-- Dropdown menu -->
    <div
      v-if="open"
      id="dropdownHover"
      class="absolute top-10 right-0 bg-white divide-y divide-gray-100 rounded-lg shadow-lg w-44 border z-[60] overflow-hidden"
    >
      <ul
        class="text-sm text-gray-700"
      >
        <slot />
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const open = ref(false);

const handleClickOutside = () => {
  open.value = false;
};
</script>

<style scoped>

</style>
